"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = void 0;

var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var lseds_1 = require("../../lseds");

exports.Box = lseds_1.lseds('div');

if (utils_1.isDev) {
  exports.Box.displayName = 'Box';
}